import { localStorage, sessionStorage } from 'dibs-browser-storage';
import { postFakeForm } from 'dibs-xdomain-poster';
import { getBuyerId } from 'dibs-cookie-jar';
import serverVars from 'server-vars';

export const MAX_SESSION_COUNT = 3;
export const SESSION_COUNT_STORAGE_KEY = 'TRADE_VERIFY_FIRM_REMINDER_TOAST_DISPLAY_SESSION_COUNT';
export const SESSION_STORAGE_KEY = 'TRADE_VERIFY_FIRM_REMINDER_TOAST_SESSION';
export const TOAST_DISMISSED_STORAGE_KEY = 'TRADE_VERIFY_FIRM_REMINDER_TOAST_DISMISSED';

function getUserId() {
    return getBuyerId(document.cookie);
}

export function dismissTradeVerifyFirmReminderToast() {
    localStorage.setItem(TOAST_DISMISSED_STORAGE_KEY, true);
}

function hasSeenToastThisSession() {
    return sessionStorage.getItem(SESSION_STORAGE_KEY);
}

function getToastSessionViewCount() {
    return localStorage.getItem(SESSION_COUNT_STORAGE_KEY) || 0;
}

export function markTradeVerifyFirmReminderToastSeen() {
    const sessionViewCount = getToastSessionViewCount();
    localStorage.setItem(SESSION_COUNT_STORAGE_KEY, sessionViewCount + 1);
    sessionStorage.setItem(SESSION_STORAGE_KEY, true);
}

export function canShowTradeVerifyFirmReminderToast() {
    const isMobile = serverVars.get('settings.isMobile') || false;
    const toastDismissed = localStorage.getItem(TOAST_DISMISSED_STORAGE_KEY) || false;
    const toastSessionViewCountExceeded = getToastSessionViewCount() >= MAX_SESSION_COUNT;

    return (
        !!getUserId() &&
        !isMobile &&
        !toastDismissed &&
        !toastSessionViewCountExceeded &&
        !hasSeenToastThisSession()
    );
}

export function postToFormAssembly({ file, message }) {
    /* eslint-disable camelcase */
    return postFakeForm('https://www.tfaforms.com/responses/processor', {
        tfa_1: file || '',
        tfa_2: getUserId(),
        tfa_3: message,
        tfa_dbControl: '70007a809c5564c85f6c7af4ab7f881c',
        tfa_dbFormId: '4738768',
        tfa_dbResponseId: '',
        tfa_dbTimeStarted: Date.now(),
        tfa_dbVersionId: '2',
        tfa_referrer: window.location.href,
        tfa_switchedoff: '',
    });
    /* eslint-enable camelcase */
}
